import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ModuleId } from "@/modules";

interface HomeStore {
  /** Anasayfanın kaç kez görüldüğü — adaptif hero için (kalıcı). */
  visits: number;
  recordVisit: () => void;
  /** Dizilimde o an açık modül — kinetik başlık bunu okur (geçici). */
  frontId: ModuleId | null;
  setFrontId: (id: ModuleId | null) => void;
  /** Persona dizilimde hover'daki kart — döngüyü durdurur; "yakında" dahil (geçici). */
  lineupHoverId: ModuleId | null;
  setLineupHoverId: (id: ModuleId | null) => void;
}

/**
 * Anasayfa durumu. İlk ziyaretlerde hero anlatı odaklı ve tam ekran;
 * alışkın kullanıcıda kısalır, "devam et" ve tile'lar öne çıkar.
 */
export const useHomeStore = create<HomeStore>()(
  persist(
    (set) => ({
      visits: 0,
      recordVisit: () => set((s) => ({ visits: s.visits + 1 })),
      frontId: null,
      setFrontId: (frontId) => set((s) => (s.frontId === frontId ? s : { frontId })),
      lineupHoverId: null,
      setLineupHoverId: (lineupHoverId) =>
        set((s) => (s.lineupHoverId === lineupHoverId ? s : { lineupHoverId })),
    }),
    { name: "home-storage", partialize: (s) => ({ visits: s.visits }) },
  ),
);
